/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import PropTypes from 'prop-types';

import { TextBlock, Stack, DisplayHtmlContent } from 'sarsaparilla';

import {
    AnchorPageWithSidebarLayout,
    AnchorPageSection,
} from 'shared-ui/components/AnchorPageWithSidebarLayout';

export function BookingTab({ bookingWindowsHtml }) {
    return (
        <AnchorPageWithSidebarLayout>
            <Stack space="lg">
                <AnchorPageSection heading="Booking Windows">
                    <TextBlock>
                        <DisplayHtmlContent html={bookingWindowsHtml} />
                    </TextBlock>
                </AnchorPageSection>
            </Stack>
        </AnchorPageWithSidebarLayout>
    );
}

BookingTab.propTypes = {
    bookingWindowsHtml: PropTypes.string,
};
